/**
 * HTML Element
 *
 */

import Anchor from '../components/Anchor'

const Link = Anchor
export default Link
